import React from 'react'

// Lazy load games to avoid bundle bloat
export const BreathingGame = React.lazy(() => import('./BreathingGame'))
export const MemoryGame = React.lazy(() => import('./MemoryGame'))
export const BubblePop = React.lazy(() => import('./BubblePop'))
